import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private scrollTrigger = new Subject<string>();
  scrollTrigger$ = this.scrollTrigger.asObservable();

  triggerScroll(sectionId: string) {
    this.scrollTrigger.next(sectionId);
  }
}
